import {
  GROUPS_LIST,
  GROUPS_LIST_SUCCESS,
  GROUPS_LIST_ERROR,
  GROUPS_NEW,
  GROUPS_NEW_SUCCESS,
  GROUPS_NEW_ERROR,
  GROUPS_EDIT,
  GROUPS_DELETE,
  GROUPS_DELETE_SUCCESS,
  GROUPS_DELETE_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
  responseNew: "",
  loadingNew: false,
  errorNew: "",
  responseDelete: "",
  loadingDelete: false,
  errorDelete: "",
}

const Groups = (state = initialState, action) => {
  switch (action.type) {
    case GROUPS_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
      }
      break
    case GROUPS_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case GROUPS_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    case GROUPS_NEW:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case GROUPS_NEW_SUCCESS:
      state = {
        ...state,
        loadingNew: false,
        responseNew: action.payload.data
      }
      break
    case GROUPS_NEW_ERROR:
      state = {
        ...state,
        loadingNew: false,
        errorNew: action.payload
      }
      break
    case GROUPS_EDIT:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case GROUPS_DELETE:
      state = {
        ...state,
        loadingDelete: true,
        responseDelete: "",
        errorDelete: ""
      }
      break
    case GROUPS_DELETE_SUCCESS:
      state = {
        ...state,
        loadingDelete: false,
        responseDelete: action.payload.data
      }
      break
    case GROUPS_DELETE_ERROR:
      state = {
        ...state,
        loadingDelete: false,
        errorDelete: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default Groups
